import React, { useEffect } from 'react';
import { useAuth } from 'src/hooks/use-auth';
import { clearViewAs } from 'src/lib/view-as/view-as-store';

export const SignOut = () => {
  const { signOut } = useAuth();
  useEffect(() => {
    clearViewAs();
    signOut();
  }, [signOut]);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <></>;
};
